import React, { useEffect, useState } from "react";
import { Button, Table } from "antd";
import styled from "styled-components";
import * as XLSX from "xlsx";
import { ReactComponent as ExcelIcon } from "../../../../icon/Excel下载.svg";
import {ReactComponent as DownloadIcon} from '../../../../../../../assets/icon/下载.svg'

// 添加样式组件
const StyledTable = styled(Table)`
  /* 表头样式 */
  .ant-table-thead > tr > th {
    background-color: #E3F2D9 !important;
    color: #75BD42 !important;
    border: 1px solid #78BF46 !important;
    font-size: 16px !important;
  }

  /* 表格内容的单元格样式 */
  .ant-table-tbody > tr > td {
    border: 1px solid #C9E6B4 !important;
    background-color: #ffffff !important;
  }

  /* 鼠标悬停时保持背景色为白色 */
  .ant-table-tbody > tr:hover > td {
    background-color: #ffffff !important;
  }
`;

function SheetCom({ List }) {
  const [columns, setColumns] = useState([]); 
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (List) {
      // 处理列配置
      const sampleColumns = [
        {
          title: 'Gene ID',
          dataIndex: 'geneId',
          key: 'geneId',
          fixed: 'left',
          width: 150
        }
      ];

      // 获取所有样本名称作为列
      const firstGene = Object.values(List)[0];
      Object.keys(firstGene).forEach(sample => {
        sampleColumns.push({
          title: sample,
          dataIndex: sample,
          key: sample,
          width: 120,
          render: (text) => Number(text).toFixed(3) // 保留3位小数
        });
      });

      // 处理表格数据
      const data = Object.entries(List).map(([geneId, values], index) => ({
        key: index,
        geneId,
        ...values
      }));

      setColumns(sampleColumns);
      setTableData(data);
    }
  }, [List]);
// CSV 转换函数
function convertToCSV(jsonData) {
  if (!jsonData || jsonData.length === 0) {
    return "";
  }

  const columns = Object.keys(jsonData[0]).slice(1);
  let csvString = columns.join(",") + "\n";

  jsonData.forEach((row) => {
    let rowString = columns
      .map((column) => {
        let value = row[column];
        if (
          typeof value === "string" &&
          (value.includes(",") || value.includes("\n") || value.includes('"'))
        ) {
          value = `"${value.replace(/"/g, '""')}"`; // 替换双引号为两个双引号
        }
        return value;
      })
      .join(",");
    csvString += rowString + "\n";
  });

  return csvString;
}

// 文件下载函数
function downloadCSV(csvString, filename) {
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = filename || "data.csv"; // 设置文件名
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
const handleDownloadCSV = () => {
  if (tableData.length === 0) {
    alert("No data to download");
    return;
  }

  // 从表单中获取 Genome 的值
  const genomeValue = "Data Sheet";

  // 如果 Genome 值为空，使用默认文件名
  const filename = genomeValue ? `${genomeValue}.csv` : "table_data.csv";

  // 将表格数据转换为 CSV 字符串
  const csvString = convertToCSV(tableData);

  // 触发文件下载
  downloadCSV(csvString, filename);
};
  return (
    <div>
       <div style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"flex-end"}}>
                <Button
                style={{border:"none"}}
                onClick={handleDownloadCSV}
                >
      <DownloadIcon width={20}/>
      CSV
                </Button>
              </div>
              <Table
      bordered
      size="small"
      style={{ width: "100%", height: "90%", margin: "10px auto" }}
      columns={columns}
      dataSource={tableData}
      scroll={{
        x: 'max-content',
        y: 500
      }}
    />
    </div>
    
  );
}

export default SheetCom;
